// `labelKey` instead of a literal label — resolved at render (see src/i18n/README.md).
export const PAYMENT_METHODS = [
    { id: 'pix', labelKey: 'insights.paymentMethods.pix' },
    { id: 'credit', labelKey: 'insights.paymentMethods.credit' },
    { id: 'card', labelKey: 'insights.paymentMethods.card' },
    { id: 'boleto', labelKey: 'insights.paymentMethods.boleto' },
    { id: 'debit', labelKey: 'insights.paymentMethods.debit' },
];

export const PAYMENT_METHOD_MAP = PAYMENT_METHODS.reduce((acc, m) => {
    acc[m.id] = m;
    return acc;
}, {});
